import React, { useEffect, useState } from 'react';
import { IPageData } from '../../../interfaces/page';
import { useFetchPageData, usePageData } from '../../../hooks/usePage';
import { Card } from 'antd';
import Tabla from './bandeja/TablaCovid19t';
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Consultar Fichas',
      route: 'bandeja-fichas'
    },
    {
      title: 'Bandeja de Fichas'
    }
  ]
};
const ConsultaSintomatologiaCovid19 = () => {
  usePageData(pageData);
  return(
    <>
      <Card title='Bandeja de Sintomatologia Covid-19'>
        <Tabla />
      </Card>
    </>
  );
}
export default ConsultaSintomatologiaCovid19;